import { Location } from 'history'
import React from 'react'
import { OrganizationConnectedPlatform } from 'src/enums'
import { appStatisticsKeys } from 'src/globalDebouncedDispatcher'
import { APIKey } from 'src/models/apiKey.models'
import { OrgExpenseReportConfirmDateChangePopupProps } from 'src/models/orgExpenseReports.models'
import { ReceiptAttachmentModel } from 'src/models/receiptAttachment.models'
import { LocationState, RootState } from 'src/redux/createRootReducer'

export const selectIsSidenavOpenFromState = (state: RootState): boolean =>
  state.app.isSidenavOpen

export const selectIsSidenavLockedOpenFromState = (state: RootState): boolean =>
  state.app.isSidenavLockedOpen

export const selectShowSidenavLargeFromState = (state: RootState): boolean =>
  state.app.showSidenavLarge

export const selectIsAlertBarOpenFromState = (state: RootState): boolean =>
  state.app.isAlertBarOpen

export const selectIsDowngradeBarOpenFromState = (state: RootState): boolean =>
  state.app.isDowngradeBarOpen

export const selectAlertMessageFromState = (
  state: RootState,
): string | undefined => state.app.alertMessage

export const selectMessageCountFromState = (
  state: RootState,
): number | undefined => state.app.messageCount

export const selectIsSessionExpiringPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isSessionExpiringPopupOpen

export const selectIsTooltipPopupOpenFromState = (state: RootState): boolean =>
  state.app.isTooltipPopupOpen

export const selectTooltipPopupMessageFromState = (
  state: RootState,
): React.ReactNode | undefined => state.app.tooltipPopupMessage

export const selectIsAttachmentPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isAttachmentPopupOpen
export const selectDeleteActionFromState = (
  state: RootState,
): (() => void) | undefined => state.app.deleteAction
export const selectAttachmentFromState = (
  state: RootState,
): ReceiptAttachmentModel | undefined => state.app.attachment

export const selectIsSendReceiptReminderPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isSendReceiptReminderPopupOpen

export const selectIsCancelOrgInvitePopupOpenFromState = (
  state: RootState,
): boolean => state.app.isCancelOrgInvitePopupOpen

export const selectIsCreateOrgIntegrationOpenFromState = (
  state: RootState,
): boolean => state.app.isCreateOrgIntegrationOpen

export const selectCreateOrgIntegrationIntegrationTypeFromState = (
  state: RootState,
): OrganizationConnectedPlatform | undefined =>
  state.app.createOrgIntegrationIntegrationType

export const selectIsOrgOwnerReassignmentPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isOrgOwnerReassignmentPopupOpen

export const selectIsDeleteAccountPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isDeactivateBudgetPopupOpen

export const selectIsOrgOwnerReassignmentFromState = (
  state: RootState,
): boolean => state.app.isOrgOwnerReassignment

export const selectIsBrandSpecificWelcomePopupOpenFromState = (
  state: RootState,
): boolean => state.app.isBrandSpecificWelcomePopupOpen

export const selectAllStatisticsLoadedFromState = (
  state: RootState,
): Record<string, boolean> => state.app.statisticsLoaded

export const selectIsCreateExpenseReportPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isCreateExpenseReportPopupOpen

export const selectIsMarkExpenseReportsPaidPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isMarkExpenseReportsPaidPopupOpen

export const selectIsCreateDeleteExpensePopupOpenFromState = (
  state: RootState,
): boolean => state.app.isDeleteExpensePopupOpen

export const selectIsCreateDeleteExpenseReportsPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isDeleteExpenseReportsPopupOpen

export const selectIsSubmitExpenseReportPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isSubmitExpenseReportPopupOpen

export const selectIsAddMissingInformationExpenseReportPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isAddMissingInformationExpenseReportPopupOpen

export const selectIsWhatsNewPopupOpenFromState = (state: RootState): boolean =>
  state.app.isWhatsNewPopupOpen

export const selectIsAddDepartmentPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isAddDeptPopupOpen
export const selectIsAcknowledgementAlertBarOpenFromState = (
  state: RootState,
): boolean => state.app.isAcknowledgementAlertBarOpen

export const selectIsAPICreatedPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isAPIKeyCreatedPopupOpen

export const selectAPIKeyCreatedAPIKeyFromState = (
  state: RootState,
): APIKey | undefined => state.app.apiKeyCreatedAPIKey

export const selectIsDeleteAPIKeyPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isDeleteAPIKeyPopupOpen

export const selectAPIKeyToDeleteFromState = (
  state: RootState,
): string | undefined => state.app.deleteAPIKeyId

export const selectAPIKeyToDeleteExpiresAtFromState = (
  state: RootState,
): string | undefined => state.app.deleteAPIKeyExpiresAt

export const selectIsSetupOrganizationPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isSetupOrganizationPopupOpen

export const selectisUploadReceiptsAutoMatchPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isUploadReceiptsAutoMatchPopupOpen

export const selectIsRemoveBudgetUserPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isRemoveBudgetUserPopupOpen

export const selectIsRequestCompletedFromState = (state: RootState): boolean =>
  state.app.isRequestCompletedPopupOpen

export const selectConfirmOrgContinueLocation = (
  state: RootState,
): string | Location<LocationState> | undefined =>
  state.app.confirmOrgContinueLocation

export const selectIsDownloadExpenseReportsPaidPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isDownloadExpenseReportsPaidPopupOpen

export const selectIsDownloadSuccessPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isDownloadSuccessPopupOpen

export const selectIsSyncTransactionsPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isSyncTransactionsPopupOpen

export const selectIsMobileWebPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isMobileWebPopupOpen

export const selectIsBulkDeactivateVirtualCardsPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isBulkDeactivateVirtualCardsPopupOpen

export const selectIsBulkCloseVirtualCardsPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isBulkCloseVirtualCardsPopupOpen

export const selectIsBulkUpdateVirtualCardsFlyoutOpenFromState = (
  state: RootState,
): boolean => state.app.isBulkUpdateVirtualCardsFlyoutOpen

export const selectIsAddSecondaryEmailPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isAddSecondaryEmailPopupOpen

// TODO(remove-require-phone-number): unreachable after `require_phone_number` flag removal — delete in follow-up PR. See cleanup-require-phone-number-deadcode.md.
export const selectIsVerifyPhoneNumberPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isVerifyPhoneNumberPopupOpen

// TODO(remove-require-phone-number): unreachable after `require_phone_number` flag removal — delete in follow-up PR. See cleanup-require-phone-number-deadcode.md.
export const selectIsUpdatePhoneNumberPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isUpdatePhoneNumberPopupOpen

export const selectIsFiltersFlyoutOpenFromState = (state: RootState): boolean =>
  state.app.isFiltersFlyoutOpen

export const selectConfirmOrgExpenseReportDateChangePopupPropsFromState = (
  state: RootState,
): OrgExpenseReportConfirmDateChangePopupProps | undefined =>
  state.app.confirmOrgExpenseReportDateChangePopupProps

export const selectIsExtraVerificationPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isExtraVerificationPopupOpen

export const selectIsChoose2faMethodPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isChoose2faMethodPopupOpen

export const selectIsBrandRedirectPopupOpenFromState = (
  state: RootState,
): boolean => state.app.isBrandRedirectPopupOpen

export const selectStatisticsDispatcherFromState = (
  state: RootState,
): ((stats: appStatisticsKeys[], cacheTimestamp?: string) => void) => {
  // must pass empty function in case state has not yet been set
  return state.app.globalDebouncedDispatchers.debouncedStatisticsDispatcher !==
    undefined
    ? state.app.globalDebouncedDispatchers.debouncedStatisticsDispatcher
    : (): void => {
        return
      }
}
